var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary mb-0"
        }, [_c('strong', [_vm._v("PMS Offline Activities")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between mb-3"
        }, [_c('div', {
          staticClass: "d-flex align-items-center flex-wrap"
        }, [_c('date-picker', {
          staticClass: "mr-2 mb-2",
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "type": "year",
            "value-type": "YYYY",
            "format": "YYYY",
            "placeholder": "Select Year"
          },
          model: {
            value: _vm.filters.year,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "year", $$v);
            },
            expression: "filters.year"
          }
        }), _c('v-multiselect', {
          staticClass: "mr-2 mb-2",
          staticStyle: {
            "width": "260px"
          },
          attrs: {
            "tag-placeholder": "Fleet Type",
            "placeholder": "Select Fleet Type",
            "label": "name",
            "track-by": "code",
            "options": _vm.fleetCategoryOpt,
            "multiple": true,
            "taggable": true
          },
          on: {
            "input": _vm.onVehicleTypeChange
          },
          model: {
            value: _vm.filters.vehicleTypeIds,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "vehicleTypeIds", $$v);
            },
            expression: "filters.vehicleTypeIds"
          }
        }), _c('v-multiselect', {
          staticClass: "mr-2 mb-2",
          staticStyle: {
            "width": "400px"
          },
          attrs: {
            "tag-placeholder": "Fleet",
            "placeholder": "Select Fleet",
            "label": "name",
            "track-by": "code",
            "options": _vm.fleetNameOpt,
            "multiple": true,
            "taggable": true,
            "loading": _vm.fleetLoading
          },
          model: {
            value: _vm.filters.vehicleIds,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "vehicleIds", $$v);
            },
            expression: "filters.vehicleIds"
          }
        }), _c('b-button', {
          staticClass: "mb-2 d-flex align-items-center text-nowrap",
          attrs: {
            "variant": "outline-primary",
            "disabled": _vm.tableLoading
          },
          on: {
            "click": _vm.applyFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders mr-1"
        }), _vm._v(" Filter Data ")])], 1)]), _vm.initialLoading ? _c('div', {
          staticClass: "text-center py-5"
        }, [_c('b-spinner', {
          attrs: {
            "label": "Loading..."
          }
        })], 1) : _c('div', {
          staticClass: "table-responsive offline-table-wrap"
        }, [_c('table', {
          staticClass: "table table-bordered table-striped table-hover mb-0 offline-table",
          class: {
            'table-loading': _vm.tableLoading
          }
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-white align-middle frozen-fleet-name",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v(" FLEET NAME ")]), _c('th', {
          staticClass: "text-white text-center year-header",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v(" " + _vm._s(_vm.selectedYear) + " ")])]), _c('tr', _vm._l(_vm.months, function (month) {
          return _c('th', {
            key: month.value,
            staticClass: "text-white text-center"
          }, [_vm._v(" " + _vm._s(month.label) + " ")]);
        }), 0)]), _c('tbody', [!_vm.rows.length ? _c('tr', [_c('td', {
          staticClass: "text-center text-muted py-4",
          attrs: {
            "colspan": "13"
          }
        }, [_vm._v(" No data available ")])]) : _vm._e(), _vm._l(_vm.paginatedRows, function (row) {
          return _c('tr', {
            key: row.id || row.vehicle_id || row.name
          }, [_c('td', {
            staticClass: "fleet-cell frozen-fleet-name"
          }, [_c('span', {
            staticClass: "fleet-badge"
          }, [_vm._v(" " + _vm._s(row.name || row.vehicle_name || '-') + " ")])]), _vm._l(_vm.months, function (month) {
            return _c('td', {
              key: "".concat(row.id || row.vehicle_id || row.name, "-").concat(month.value),
              staticClass: "text-center"
            }, [_vm.getMonthFile(row, month) ? _c('b-dropdown', {
              staticClass: "activity-action",
              attrs: {
                "size": "sm",
                "variant": "outline-primary",
                "text": "Available"
              }
            }, [_c('b-dropdown-item', {
              on: {
                "click": function click($event) {
                  _vm.downloadFile(_vm.getMonthFile(row, month));
                }
              }
            }, [_vm._v(" Download ")]), _c('b-dropdown-item', {
              on: {
                "click": function click($event) {
                  return _vm.openOfflineActivityModal(row, month);
                }
              }
            }, [_vm._v(" Edit ")])], 1) : _c('button', {
              staticClass: "not-available",
              attrs: {
                "type": "button"
              },
              on: {
                "click": function click($event) {
                  return _vm.openOfflineActivityModal(row, month);
                }
              }
            }, [_vm._v(" Not Available ")])], 1);
          })], 2);
        })], 2)])]), !_vm.initialLoading ? _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('div', [_c('span', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows : "), _c('strong', [_vm._v(_vm._s(_vm.totalRows))])])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.filters.limit,
            "first-number": "",
            "align": "center"
          },
          model: {
            value: _vm.filters.page,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "page", $$v);
            },
            expression: "filters.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.onChangeLimit
          },
          model: {
            value: _vm.filters.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "limit", $$v);
            },
            expression: "filters.limit"
          }
        })], 1)]) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "title": _vm.offlineActivityModalTitle,
      "hide-footer": "",
      "centered": "",
      "size": "md",
      "body-class": "pb-3"
    },
    model: {
      value: _vm.offlineActivityModal.show,
      callback: function callback($$v) {
        _vm.$set(_vm.offlineActivityModal, "show", $$v);
      },
      expression: "offlineActivityModal.show"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitOfflineActivity.apply(null, arguments);
      }
    }
  }, [_c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.offlineActivityModal.monthLabel,
      "readonly": ""
    }
  }), _c('b-form-textarea', {
    staticClass: "mb-4",
    attrs: {
      "rows": "4",
      "max-rows": "6",
      "placeholder": "Insert activity link..."
    },
    model: {
      value: _vm.offlineActivityModal.url,
      callback: function callback($$v) {
        _vm.$set(_vm.offlineActivityModal, "url", $$v);
      },
      expression: "offlineActivityModal.url"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "modal-action-btn mr-2",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.offlineActivityModal.loading
    },
    on: {
      "click": _vm.closeOfflineActivityModal
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-button', {
    staticClass: "modal-action-btn",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.offlineActivityModal.loading
    }
  }, [_vm.offlineActivityModal.loading ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Submit ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }